import React, { useState, useEffect } from "react";

import "./Cancel.css";
import { api_call } from "../../utils/Network";

function Cancel() {
  const [displayData, setDisplayData] = useState({ point: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    api_call
      .get(`service_list/terms_data/Cancel-Resch/info/`)
      .then((response) => {
        setDisplayData(response.data.data);
      });
  };

  return (
    <div className="cancel_main">
      <h1>Cancellation & Refund Policy</h1>
      <div dangerouslySetInnerHTML={{ __html: `${displayData.point}` }}></div>
    </div>
  );
}

export default Cancel;
